"use client";
import { cn } from "@/lib/utils";

export default function Section({
  id,
  wrapperClassName,
  className,
  children,
  as,
}) {
  const Element = as || "section";
  return (
    <Element id={id} className={cn(wrapperClassName)}>
      <div className={cn("content", className)}>{children}</div>
    </Element>
  );
}
